/* eslint-disable @typescript-eslint/no-explicit-any */
'use client';

import { useMemo } from 'react';

import Header from '@/components/layout/Header';
import Footer from '@/components/layout/Footer';
import ErrorContent from '@/components/layout/ErrorContent';

import { getRuntimeOrg } from '@/utils/runtimeOrg';

import { bometConfig } from '@/config/bomet.config';
import { nyandaruaConfig } from '@/config/nyandarua.config';
import { baringoConfig } from '@/config/baringo.config';
import { limsConfig } from '@/config/lims.config';

const ORG_MAP: Record<string, any> = {
  bomet: bometConfig,
  nyandarua: nyandaruaConfig,
  baringo: baringoConfig,
  lims: limsConfig,
};

export default function RouteError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const cfg = useMemo(() => {
    const htmlOrg =
      typeof document !== 'undefined'
        ? document.documentElement.dataset.org
        : undefined;
    const org = (htmlOrg || getRuntimeOrg() || 'nyandarua').toLowerCase();

    return ORG_MAP[org] ?? nyandaruaConfig;
  }, []);

  return (
    <>
      <Header
        cfg={{
          name: cfg.name,
          logo: (cfg as any).logo,
          header: (cfg as any).header,
        }}
      />
      <main className="flex-1">
        <ErrorContent error={error} reset={reset} />
      </main>
      <Footer
        cfg={{
          name: cfg.name,
          logo: (cfg as any).logo,
          footer: (cfg as any).footer,
          contact: (cfg as any).contact,
        }}
      />
    </>
  );
}
